








import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ui-toolbar-item"
})
export default class UiToolbarItemComponent extends Vue {
  @Prop({ default: "" })
  icon: string;

  @Prop({ default: true })
  auto: boolean;

  @Prop({ default: false })
  right: boolean;

  @Prop({ default: "" })
  color: string;

  click() {
    this.$emit("click");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-toolbar/src/ui-toolbar-item.vue